import { Layout } from '../components/Layout';
import { AmplifyUserProvider } from '../context/AmplifyUserProvider';
import { Router } from './router';

export function CatalogApp() {
  return (
    <AmplifyUserProvider>
      <Layout>
        <Router />
      </Layout>
    </AmplifyUserProvider>
  );
}

CatalogApp.displayName = 'CatalogApp';
